import { render, staticRenderFns } from "./AuthPopup.vue?vue&type=template&id=98bb5e70&scoped=true&"
import script from "./AuthPopup.vue?vue&type=script&lang=js&"
export * from "./AuthPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bb5e70",
  null
  
)

export default component.exports